export default __webpack_public_path__ + "images/landing-8pIG4.png";